import script from "./studentList.vue?vue&type=script&setup=true&lang=js"
export * from "./studentList.vue?vue&type=script&setup=true&lang=js"

import "./studentList.vue?vue&type=style&index=0&id=c15949ec&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c15949ec"]])

export default __exports__